import { render, staticRenderFns } from "./GlobalFleet.vue?vue&type=template&id=278e72c7"
import script from "./GlobalFleet.vue?vue&type=script&lang=js"
export * from "./GlobalFleet.vue?vue&type=script&lang=js"
import style0 from "./GlobalFleet.vue?vue&type=style&index=0&id=278e72c7&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports